import React from "react";
import "./styles/TermsOfService.css";
import test from './../assets/termsConditions.webp';
import { Link } from "react-router-dom";
import SEO from "../seo/SEO";
import config from "../config/config";

const TermsOfService = () => {
  return (
    <>
        <SEO
            robots="noindex, follow"
            title="Terms of Service - Withrow Knives"
            description="Read Withrow Knives' Terms of Service to understand your rights and responsibilities when using our website and services."
            url={`${config.metadata.siteUrl}/terms-of-service`}
        />

        <div className="page-wrapper">
          <div 
            className="page-title" 
            style={{ backgroundImage: `url(${test})`, backgroundSize: "cover", backgroundPosition: "center" }}
          >
            <h1>Terms of Service</h1>
            <p className="page-subtitle">Last updated March 27, 2025.</p>
          </div>

          <div className="page-content-section terms-content">

            <section aria-labelledby="tos-agreement-title">
              <h2 id="tos-agreement-title">Agreement to Our Legal Terms</h2>
              <p>
                By using this website and our services ("Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree, you must discontinue use.
              </p>
              <p>
                These Terms are a legal agreement between you and <strong>Withrow Knives</strong> ("we", "us", or "our") and govern your access to and use of our site. Our Services are intended for users who are at least 18 years old.
              </p>
            </section>

            <section aria-labelledby="tos-our-services-title">
              <h2 id="tos-our-services-title">Our Services</h2>
              <p>
                Withrow Knives provides handcrafted knives and related accessories through our online platform. We strive for accuracy but do not guarantee that all product descriptions or images are error-free or up to date at all times.
              </p>
            </section>

            <section aria-labelledby="tos-purchases-payments-title">
              <h2 id="tos-purchases-payments-title">Purchases and Payments</h2>
              <p>
                When placing an order, you agree to provide accurate and complete information. Prices, product availability, and shipping costs are subject to change without notice. All payments are processed securely through third-party services (e.g., Stripe).
              </p>
            </section>

            <section aria-labelledby="tos-returns-title">
              <h2 id="tos-returns-title">Return Policy</h2>
              <p>
                Please review our <Link to="/shipping-returns" aria-label="Read our return policy">Shipping & Returns Policy</Link> for detailed information on returns, repairs, and refunds.
              </p>
            </section>

            <section aria-labelledby="tos-prohibited-activities">
              <h2 id="tos-prohibited-activities">Prohibited Activities</h2>
              <p>
                Certain items on our website may be subject to federal, state, or local laws regarding age and eligibility for purchase.
                By completing a purchase, you affirm that you meet the minimum legal age requirement to purchase the product in your shipping location.
              </p>
              <p>
                During checkout, we require you to confirm your age and legal eligibility by checking a box that serves as your electronic signature.
                This age requirement is dynamically updated based on the shipping address provided, in accordance with local and state laws (e.g., some states require buyers to be 18+, others 21+).
              </p>
              <p>You also certify that all information you provide, including your name and shipping address, is accurate and truthful.</p>
              
            </section>

            <section aria-labelledby="tos-prohibited-activities">
              <h2 id="tos-prohibited-activities">Prohibited Activities</h2>
              <p>
                You agree not to:
              </p>
              <ul>
                <li>Use the site for any unlawful or fraudulent purposes</li>
                <li>Access or tamper with non-public areas of the site</li>
                <li>Attempt to breach security or interfere with the site's operation</li>
                <li>Misrepresent your identity or impersonate another person</li>
                <li>Place an order or complete a purchase if you are under the age of 18</li>
              </ul>
            </section>

            <section aria-labelledby="tos-dispute-title">
              <h2 id="tos-dispute-title">Dispute Resolution</h2>
              <p>
              These Terms are governed by the laws of the State of West Virginia, without regard to its conflict of law principles. Any disputes shall first be attempted to be resolved informally. If unresolved, disputes may be subject to arbitration or adjudication in a court of competent jurisdiction.
              </p>
            </section>

            <section aria-labelledby="tos-modifications-title">
              <h2 id="tos-modifications-title">Modifications to Terms</h2>
              <p>
                We may revise these Terms at any time. Changes will be posted on this page with the "Last Updated" date above. Your continued use of the Services after changes are posted constitutes your acceptance of the revised Terms.
              </p>
            </section>

            <section aria-labelledby="tos-contact-title">
              <h2 id="tos-contact-title">Contact Us</h2>
              <p>
                If you have any questions regarding these Terms of Service, please reach out:
              </p>
              <div className="terms-contact">
                <strong>Email:</strong> <a href={`mailto:${config.contactEmail}`}>{config.contactEmail}</a><br />

                Or <Link to="/contact">click here</Link> to submit a contact form.
              </div>
            </section>
          </div>
        </div>

    </>
  );
};

export default TermsOfService;